<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ILEyrr/tc-custom/9783968652986.jpg?1702957367062" alt="This image is the cover for the book The Day of the Beast, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Day of the Beast, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>It is the story of Daren Lane, who returns from the battlefields of World War I to a society tired of hearing about the war and declining morals. It is set in Middletown USA. It is set on the Victorian era's side in the culture conflict with the Roaring Twenties.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zane Grey
      </h2>
      
      <p class="authorDescription body article">Pearl Zane Grey (January 31, 1872 – October 23, 1939) was an American author and dentist best known for his popular adventure novels and stories associated with the Western genre in literature and the arts; he idealized the American frontier. Riders of the Purple Sage (1912) was his best-selling book. In addition to the commercial success of his printed works, his books have had second lives and continuing influence when adapted as films and television productions. His novels and short stories have been adapted into 112 films, two television episodes, and a television series, Dick Powell's Zane Grey Theater.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a62f50a